import type { FunctionComponent } from "react";

import { Text } from "@smartsuite/react-ui/lib";

import { StyledWrapper } from "./styles";

interface SubConditionItemProps {
  caption: string;
  value: string;
}

// eslint-disable-next-line import/no-unused-modules -- consumed by the upcoming Conditional Logic branches UI (Tasks 6-7)
export const SubConditionItem: FunctionComponent<SubConditionItemProps> = ({
  caption,
  value,
}) => {
  return (
    <StyledWrapper>
      <Text size="s" color="tertiary">
        {caption}
      </Text>
      <Text size="m" color="primary">
        {value}
      </Text>
    </StyledWrapper>
  );
};
